export default "__VITE_ASSET__D_j8v9MP__"